import React from 'react'
import PropTypes from 'prop-types'
import * as S from './ActionList.styled'
import { buttonFrom } from '../Button/utils'

export const ActionList = ({ heading, items, onClick: onListItemClick }) => {
  return (
    <S.ActionList>
      {items && (
        <React.Fragment>
          {heading && <S.ActionListHeading>{heading}</S.ActionListHeading>}
          {items.map((item, index) => {
            let actionItem = {
              ...item,
            }
            if (onListItemClick) {
              const handleClick = e => {
                const { onClick: onItemClick } = item
                onListItemClick(item)
                if (onItemClick) {
                  onItemClick(e)
                }
              }
              actionItem = {
                ...actionItem,
                onClick: handleClick,
              }
            }

            return <S.ActionListItem key={`${index}Item`}>{buttonFrom(actionItem)}</S.ActionListItem>
          })}
        </React.Fragment>
      )}
    </S.ActionList>
  )
}

ActionList.propTypes = {
  heading: PropTypes.string,
  items: PropTypes.array,
  onClick: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/components/ActionList/ActionList.js